import { periodLabel, shiftPeriod, currentPeriodKey } from '../../services/format';

interface Props {
  value: string;
  onChange: (key: string) => void;
  status?: 'open' | 'closed';
}

/** Monats-Wähler (« Vormonat · Monat Jahr · Folgemonat ») mit Perioden-Status. */
export function PeriodPicker({ value, onChange, status }: Props) {
  const isCurrent = value === currentPeriodKey();
  return (
    <div className="flex items-center gap-2">
      <button type="button" className="px-2 py-1 rounded border" onClick={() => onChange(shiftPeriod(value, -1))} aria-label="Vormonat">‹</button>
      <span className="font-semibold min-w-[10rem] text-center">{periodLabel(value)}</span>
      <button type="button" className="px-2 py-1 rounded border" onClick={() => onChange(shiftPeriod(value, 1))} disabled={isCurrent} aria-label="Folgemonat">›</button>
      {status && (
        <span className={`badge ${status === 'closed' ? 'bg-slate-200 text-slate-700' : 'bg-green-100 text-green-800'}`}>
          {status === 'closed' ? 'abgeschlossen' : 'offen'}
        </span>
      )}
      {!isCurrent && (
        <button type="button" className="text-xs text-primary-600 hover:underline" onClick={() => onChange(currentPeriodKey())}>aktueller Monat</button>
      )}
    </div>
  );
}
